import React from 'react';
import { BarChart3, TrendingUp, Users, DollarSign, ArrowUpRight, Download } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
const data = [{
  name: 'Jan',
  seats: 400,
  revenue: 2400
}, {
  name: 'Feb',
  seats: 600,
  revenue: 3600
}, {
  name: 'Mar',
  seats: 800,
  revenue: 4800
}, {
  name: 'Apr',
  seats: 1200,
  revenue: 7200
}, {
  name: 'May',
  seats: 1500,
  revenue: 9000
}, {
  name: 'Jun',
  seats: 2100,
  revenue: 12600
}];
export function Reports() {
  return <div className="space-y-6 max-w-[1600px] mx-auto" data-id="element-713">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-714">
        <div data-id="element-715">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-716">Deep Analytics</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-717">
            Analyze network growth, seat density, and regional performance.
          </p>
        </div>
        <button className="px-6 py-2.5 bg-white border border-gray-200 rounded-lg text-sm font-bold text-gray-600 hover:bg-gray-50 transition-all flex items-center gap-2 shadow-sm" data-id="element-718">
          <Download size={18} data-id="element-719" />
          Export Full Report
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-720">
        <div className="lg:col-span-2 bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-721">
          <h3 className="font-bold text-slate-900 mb-6" data-id="element-722">
            Seat Growth vs. Revenue
          </h3>
          <div className="h-[300px]" data-id="element-723">
            <ResponsiveContainer width="100%" height="100%" data-id="element-724">
              <AreaChart data={data} data-id="element-725">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" data-id="element-726" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#94A3B8'
              }} data-id="element-727" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#94A3B8'
              }} data-id="element-728" />
                <Tooltip data-id="element-729" />
                <Area type="monotone" dataKey="revenue" stroke="#4F46E5" fill="#4F46E5" fillOpacity={0.1} data-id="element-730" />
                <Area type="monotone" dataKey="seats" stroke="#10B981" fill="#10B981" fillOpacity={0.1} data-id="element-731" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-732">
          <h3 className="font-bold text-slate-900 mb-6" data-id="element-733">
            Regional Performance
          </h3>
          <div className="h-[300px]" data-id="element-734">
            <ResponsiveContainer width="100%" height="100%" data-id="element-735">
              <BarChart data={data} data-id="element-736">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" data-id="element-737" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#94A3B8'
              }} data-id="element-738" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 12,
                fill: '#94A3B8'
              }} data-id="element-739" />
                <Tooltip data-id="element-740" />
                <Bar dataKey="seats" fill="#4F46E5" radius={[4, 4, 0, 0]} data-id="element-741" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}